/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_Err_RateInputs */

const en_st_wl_err_rate = /** @type {(inputs: St_Wl_Err_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Try again later.`)
};

const id_st_wl_err_rate = /** @type {(inputs: St_Wl_Err_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlalu banyak percobaan. Coba lagi nanti.`)
};

/**
* | output |
* | --- |
* | "Too many attempts. Try again later." |
*
* @param {St_Wl_Err_RateInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_err_rate = /** @type {((inputs?: St_Wl_Err_RateInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_Err_RateInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_err_rate(inputs)
	return en_st_wl_err_rate(inputs)
});